import { EP_GET_PRINT_INSTOCKS, EP_GET_PRINT_ORDER_INFOS, EP_GET_PRINT_PURCHASE_INFOS } from '../constants/endpointConstants';
import api from './Api';

const getPrintPurchaseInfo = async (searchDates) => {
    const response = await api.post(EP_GET_PRINT_PURCHASE_INFOS, searchDates);
    return response.data;
};

const getPrintOrderInfo = async (searchDates) => {
    const response = await api.post(EP_GET_PRINT_ORDER_INFOS, searchDates);
    return response.data;
};

const getPrintInstocks= async () => {
    const response = await api.post(EP_GET_PRINT_INSTOCKS);
    return response.data;
};


export {getPrintPurchaseInfo, getPrintOrderInfo, getPrintInstocks}